module.exports = __webpack_public_path__ + "img/brand-icon3.d121028a.jpg";